/** Exact transport classification. Unknown POST actions remain mutations. */
const backupReads = new Set([
  'recovery-overview', 'recovery-registry', 'recovery-policy',
  'recovery-list-operations', 'recovery-get-operation', 'recovery-list-sets',
  'recovery-get-set', 'recovery-download-manifest', 'recovery-notifications', 'recovery-preview-policy',
  'recovery-notification-detail', 'recovery-acceptance', 'recovery-access-policy',
  'recovery-inventory-review', 'recovery-storage-lifecycle', 'recovery-cutover',
  'recovery-readiness', 'recovery-demo-readiness', 'recovery-project-conflicts',
  'list-backups', 'list-vaults', 'get-backup-plan', 'estimate-costs', 'list-resources',
  'list-schedules', 'list-backup-contents', 'list-jobs', 'list-catalogue',
  'list-vaults-status', 'list-rehearsals', 'list-evidence',
]);
export function isObservationRequest(method: string, path: string, data: unknown): boolean {
  if (method.toLowerCase() === 'get') return true;
  if (method.toLowerCase() !== 'post' || path !== '/backup' || !data || typeof data !== 'object' || Array.isArray(data)) return false;
  return backupReads.has(String((data as Record<string, unknown>).action ?? ''));
}
